// extracted by mini-css-extract-plugin
export default {"search":"risks_search__TTxIZ","fieldRow":"risks_fieldRow__g2WFW","field":"risks_field__qI+w0","count":"risks_count__pfkJx","list":"risks_list__X2VeP"};